import { Component, OnInit } from '@angular/core';
import { BasketsService } from 'src/app/services/baskets.service';
import { ProductsService } from 'src/app/services/products.service';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersService } from 'src/app/services/orders.service';
import { MetaService } from 'src/app/services/meta.service';
import { UserService } from 'src/app/services/user.service';

import * as moment from 'moment';

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.css']
})
export class CreateOrderComponent implements OnInit {

  baskets = [];
  products = [];
  serviceAgents = [];

  user: any = '';

  pricing: any = {};

  deliveryDates = {
    deliveryOne: '',
    deliveryTwo: '',
    deliveryThree: '',
    deliveryFour: '',
  }

  address = {
    addressID: '',
    contactPerson: '',
    mobile: '',
    houseNo: '',
    street: '',
    building: '',
    city: ''
  }

  order = {
    baskets: [],
    products: [],
    email: '',
    deliveryDates: [],
    orderType: 'One Delivery',
    transactionType: 'Cash on Delivery',
    mobile: '',
    couponCode: '',
    reorder: false
  }

  constructor(private basketsService: BasketsService, private productsService: ProductsService, private orderService: OrdersService, private usersService: UserService, private META: MetaService, private snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.basketsService.getBaskets().subscribe(result => {
      this.baskets = result.data;
    });

    this.productsService.getProducts().subscribe(result => {
      this.products = result.data;
    });

    this.route.queryParams.subscribe(params => {
      const data = new FormData();
      data.append('mobile', params.mobile);

      this.usersService.getUsersAdAdmin(data).subscribe(result => {
        if (result.success) {
          this.user = result.data[0];
          this.order.mobile = this.user.mobile
        }
      }, error => {
        this.snackBar.open(error.error.data, 'Dismiss', {
          duration: 3000
        });
      });
    });
  }

  onAddBasket(ID, Name, Qty) {
    if (Qty == '') {
      this.snackBar.open('Quantity cannot be empty', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    if (Qty == 0) {
      this.snackBar.open('Quantity cannot be 0', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    const data = {
      _id: ID,
      name: Name,
      quantity: Qty
    }
    this.order.baskets.push(data);
    this.calculatePrice();
  }

  onAddProduct(ID, Name, Qty) {
    if (Qty == '') {
      this.snackBar.open('Quantity cannot be empty', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    if (Qty == 0) {
      this.snackBar.open('Quantity cannot be 0', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    const data = {
      _id: ID,
      name: Name,
      quantity: Qty
    }
    this.order.products.push(data);
    this.calculatePrice();
  }

  onRemoveBasket(ID) {
    this.order.baskets = this.order.baskets.filter(product => product._id !== ID);
    this.calculatePrice();
  }

  onRemoveProduct(ID) {
    this.order.products = this.order.products.filter(product => product._id !== ID);
    this.calculatePrice();
  }

  onReorder(event) {
    this.order.reorder = event.checked;
  }

  onCreateOrder() {

    const validator = this.validations();
    if (validator === null) {
      return;
    }

    if (this.order.orderType === 'One Delivery' && this.deliveryDates.deliveryOne !== '') {
      this.order.deliveryDates = [moment(this.deliveryDates.deliveryOne).format('DD-MM-YYYY').toString()];
    }

    if (this.order.orderType === 'Subscription' && (this.deliveryDates.deliveryOne !== '' || this.deliveryDates.deliveryTwo !== '' || this.deliveryDates.deliveryThree !== '' || this.deliveryDates.deliveryFour !== '')) {
      this.order.deliveryDates = [
        moment(this.deliveryDates.deliveryOne).format('DD-MM-YYYY').toString(),
        moment(this.deliveryDates.deliveryTwo).format('DD-MM-YYYY').toString(),
        moment(this.deliveryDates.deliveryThree).format('DD-MM-YYYY').toString(),
        moment(this.deliveryDates.deliveryFour).format('DD-MM-YYYY').toString()
      ];
    }

    let baskets = [];
    let products = [];

    if (this.order.baskets.length != 0) {
      this.order.baskets.map(basket => {
        const updatedBasket = {
          _id: basket._id,
          quantity: basket.quantity
        }
        baskets.push(updatedBasket);
      });
    }

    if (this.order.products.length != 0) {
      this.order.products.map(product => {
        const updatedProducts = {
          _id: product._id,
          quantity: product.quantity
        }
        products.push(updatedProducts);
      });
    }

    const data = new FormData();

    data.append('baskets', JSON.stringify(baskets));
    data.append('products', JSON.stringify(products));
    data.append('orderType', this.order.orderType);
    data.append('transactionType', this.order.transactionType);
    // data.append('transactionType', 'Cash on Delivery');
    data.append('mobile', this.order.mobile);
    data.append('deliveryDates', JSON.stringify(this.order.deliveryDates));

    if (this.order.orderType == 'Subscription') {
      data.append('reorder', JSON.stringify(this.order.reorder));
    }

    if (this.address.addressID !== '') {
      data.append('addressID', this.address.addressID);
    } else {
      delete this.address.addressID;
      this.address.mobile = this.order.mobile;
      if (this.address.building == '') {
        this.address.building = '-';
      }
      data.append('address', JSON.stringify(this.address));
    }

    if (this.order.couponCode !== '') {
      data.append('couponCode', this.order.couponCode);
    }

    this.orderService.createOrderAsAdmin(data).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/users/orders/'], { queryParams: { mobile: this.order.mobile } });
        this.snackBar.open('Order placed successfully', 'Dismiss', {
          duration: 3000
        })
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })
  }

  onOrderTypeChange() {
    this.calculatePrice();
  }

  onAddCouponCode() {
    this.calculatePrice();
  }

  calculatePrice() {
    const data = new FormData()

    let baskets = [];
    let products = [];

    if (this.order.baskets.length != 0) {
      this.order.baskets.map(basket => {
        const updatedBasket = {
          _id: basket._id,
          quantity: basket.quantity
        }
        baskets.push(updatedBasket);
      });
    }

    if (this.order.products.length != 0) {
      this.order.products.map(product => {
        const updatedProducts = {
          _id: product._id,
          quantity: product.quantity
        }
        products.push(updatedProducts);
      });
    }

    data.append('baskets', JSON.stringify(baskets));
    data.append('products', JSON.stringify(products));
    data.append('mobile', this.order.mobile);
    data.append('orderType', this.order.orderType);

    if (this.order.couponCode !== '') {
      data.append('couponCode', this.order.couponCode);
    }

    this.orderService.calculatePriceAsAdmin(data).subscribe(result => {
      if (result.success) {
        this.pricing = result.data;
      }
    }, error => {
      this.pricing = error.error.data;
    });
  }

  validations(): string {
    if (this.order.orderType === 'One Delivery' && this.deliveryDates.deliveryOne === '') {
      this.snackBar.open('Delivery date cannot be empty', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.order.orderType === 'Subscription' && (this.deliveryDates.deliveryOne === '' || this.deliveryDates.deliveryTwo === '' || this.deliveryDates.deliveryThree === '' || this.deliveryDates.deliveryFour === '')) {
      this.snackBar.open('Please select all four delivery dates', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.order.orderType == '') {
      this.snackBar.open('Order type cannot be none or empty', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.address.addressID !== '' && (this.address.contactPerson !== '' || this.address.houseNo !== '' || this.address.street !== '' || this.address.building !== '' || this.address.city !== '')) {
      this.snackBar.open('You cannot have both a new address and an existing address selected', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.address.addressID == '' && this.address.contactPerson == '' && this.address.houseNo == '' && this.address.street == '' && this.address.building == '' && this.address.city == '') {
      this.snackBar.open('Please select an address or enter a new address', 'Dismiss', {
        duration: 3000
      });
      return null;
    }
  }
}
